/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import Button from '../../../components/Button'
import { useNavigate } from 'react-router-dom'

export default function Noresult({ title, path ,subtitle, nosearch }) {
    const navigate = useNavigate()
    return (
        <div>
            <div className="flex justify-center items-center pt-[45px]">
                <div className="flex flex-col text-center items-center">
                    <img src="/assets/images/empty.png" className={`${path ? 'w-[250px] h-[200px] object-cover': ''}`} alt=""  />
                    {/* <p className=" text-lg font-normal text-black">
                        We couldn't find what you searched for. <br /> Please try a
                        different search or try again
                    </p> */}
                    <div className='w-fit'>
                        <p className=" text-base font-normal text-black mt-3">{title}</p>
                        <p className=" text-base font-normal text-black">{subtitle}</p>
                        {path && <button className='bg-primary w-full rounded-[12px] mt-3 px-4 py-2 text-white' onClick={() => navigate(path)}>Add</button>}
                    </div>

                </div>
            </div>
        </div>
    )
}
